var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.273 11.4a.6.6 0 0 1 .6.6v7.272a2.42 2.42 0 0 1-2.418 2.418H6.545a2.42 2.42 0 0 1-2.417-2.418V12a.6.6 0 1 1 1.2 0v7.272a1.22 1.22 0 0 0 1.218 1.219h10.91a1.22 1.22 0 0 0 1.217-1.22V12a.6.6 0 0 1 .6-.6m-7.39-9.08a.6.6 0 0 1 .232 0q.04.01.077.023.018.005.035.011.034.015.065.034.02.01.04.022a.6.6 0 0 1 .093.075L16.06 6.12a.6.6 0 0 1-.848.848L12.6 4.356v10.371a.6.6 0 1 1-1.2 0V4.356L8.788 6.969a.6.6 0 1 1-.848-.848l3.636-3.636a.6.6 0 0 1 .143-.104q.025-.015.053-.027.016-.006.035-.01.037-.016.077-.024"
  })));
};
export default SvgShare;